import cs from "classnames";
import React from "react";
import { MdOutlineSearch } from "react-icons/md";

import "./DataTableToolbar.css";

export const DataTableToolbar: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="data-table-toolbar">{children}</div>;

export const DataTableTitle: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="data-table-title">{children}</div>;

interface DataTableSearchProps {
	placeholder: string;
	query: string;
	setQuery(query: string): unknown;
}

export const DataTableSearch: React.FunctionComponent<DataTableSearchProps> = ({
	placeholder,
	query,
	setQuery
}) => {
	const [isFocused, setFocused] = React.useState(false);

	const onFocus = React.useCallback(() => {
		setFocused(true);
	}, []);

	const onBlur = React.useCallback(() => {
		setFocused(false);
	}, []);

	const onChange = React.useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			setQuery(event.target.value);
		},
		[setQuery]
	);

	return (
		<div
			className={cs("data-table-search", {
				"data-table-search--focused": isFocused
			})}
		>
			<MdOutlineSearch />
			<input
				type="text"
				placeholder={placeholder}
				value={query}
				onFocus={onFocus}
				onBlur={onBlur}
				onChange={onChange}
			/>
		</div>
	);
};

export const DataTableWrapper: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="data-table-wrapper">{children}</div>;

export const EmptyDataTableMessage: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => (
	<div className="empty-data-table-message">{children}</div>
);
